import { useState } from 'react';
import { axiosInstance } from '../services/axiosConfig';
import { BASE_URL, VALIDATE_CLIENT_INSTITUTE } from '../utility/constants';

/**
 * Custom hook to validate client_id and institute_id relationship
 * @returns {Object} { validateClientInstitute, isLoading }
 */
const useValidateClientInstitute = () => {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Validates that a client_id is associated with an institute_id
   * @param {string} clientId - The client identifier
   * @param {string} instituteId - The institute identifier
   * @throws {Error} If validation fails (invalid relationship, not found, etc.)
   */
  const validateClientInstitute = async (clientId, instituteId) => {
    setIsLoading(true);
    
    try {
      const response = await axiosInstance.post(
        `${BASE_URL}${VALIDATE_CLIENT_INSTITUTE}`,
        {
          client_id: clientId,
          institute_id: instituteId
        }
      );

      console.log('Validation response:', response.data);
      console.log('Response status:', response.status);

      // If we get a 200 OK status, treat it as success
      // The backend should return error status codes (400, 404, 500) for failures
      if (response.status === 200) {
        // Check if there's an explicit error in the response body
        if (response.data?.success === false || response.data?.error) {
          throw new Error(response.data?.message || response.data?.error || 'Validation failed');
        }
        
        console.log('Validation successful, proceeding with auth');
        return response.data;
      }
      
      // If status is not 200, throw an error
      throw new Error(response.data?.message || 'Validation failed');
    } catch (error) {
      console.error('Validation error:', error);
      console.error('Error response:', error.response?.data);
      
      // Extract error message from response if available
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Invalid url';
      
      // Throw error so it can be caught by the calling code
      throw new Error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return { validateClientInstitute, isLoading };
};

export default useValidateClientInstitute;

